module.exports = __webpack_public_path__ + "static/media/f4.089a2f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f4.png
// module id = 1215
// module chunks = 0